import { useState, useEffect } from 'react';

/**
 * Hook to track window scroll position
 * @param {number} threshold - The scroll position threshold to trigger the change (default: 50)
 * @returns {boolean} - Whether the scroll position has passed the threshold
 */
const useScrollPosition = (threshold = 50) => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return hasScrolled;
};

export default useScrollPosition; 